export default "__VITE_ASSET__1HsxKLzL__"